import * as React from 'react';
import { brandPrimary } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	fill?: string;
	height?: number;
	width?: number;
}

export const CropIcon: React.FC<IProps> = ({ className, fill = brandPrimary, height = 20, width = 20 }) => (
	<SvgIcon
		className={`cropIcon ${className ?? ''}`}
		fill='none'
		height={height}
		viewBox='0 0 20 20'
		width={width}
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M5 1V13C5 14.1046 5.89543 15 7 15H19'
			stroke={fill}
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth={2}
		/>
		<path
			d='M1 5H13C14.1046 5 15 5.89543 15 7V19'
			stroke={fill}
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth={2}
		/>
	</SvgIcon>
);
